export default function(router) {
  router.afterEach((to, from) => {
    if (window._hmt) {
      if (to.path && to.matched.length > 0) {
        var pathName = window.location.pathname
        var search = window.location.search || ''
        var url = pathName + search + '#' + to.fullPath
        window._hmt.push(['_trackPageview', url])
      }
    }
  })
}
